import { ApiService as api } from '@/services/axiosHelper';

export default new (class CustomerService {
	constructor() {}

	async UpdateFavorite({ id, favorite }) {
		return await api.post('/favorite', { id, favorite });
	}

	async VueLoginBypass(payload) {
		let email = Array.isArray(payload.email)
			? payload.email[0]
			: payload.email;
		Object.assign(payload, { email: email });
		return await api.post('/vueloginbypass', payload);
	}
})();
